import MuiLocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type LocationOnOutlinedProps = SvgIconProps;

export const LocationOnOutlined = (props: LocationOnOutlinedProps) => {
  return <MuiLocationOnOutlined {...props} />;
};
